import React from "react";
import { makeStyles } from "@mui/styles";
import Button from '@mui/material/Button';

const useStyles = makeStyles((theme) => ({
  button: {
    color: "white !important",
    fontSize: '15px !important',
    fontFamily: 'Roboto',
    padding: '8px 10px',
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:focus': {
      outline: 'none'
    },

    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1) !important'
    },

    '&:disabled': {
      color: "grey !important",
    }
  }
}));

const TextButton = (props) => {
  const classes = useStyles();
  return (
    <Button disabled={props.disabled} className={classes.button} onClick={props.onClick}>{ props.text }</Button>
  );
};

export default TextButton;
